import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import {capitalize} from 'util/NameUtil';

import {ChatType} from '../ChatConstants';
import {getChatTypes, getChatTypeText} from './ChatTypeUtil';

export function NewChatDropdown({
  buttonSize,
  onClick,
  activeNewChatType,
}: {
  buttonSize: ButtonSize;
  onClick: (chatType: ChatType) => void;
  activeNewChatType: ChatType | null;
}): JSX.Element | null {
  const chatTypes = getChatTypes();
  if (chatTypes.length === 0) {
    return null;
  } else if (chatTypes.length === 1 || false) {
    const chatType = chatTypes[0];
    return (
      <Tooltip text={`New ${getChatTypeText(chatType)} chat`}>
        <Button
          buttonStyle={ButtonStyle.TERTIARY_BLUE}
          size={buttonSize || ButtonSize.SMALL}
          onClick={() => {
            onClick(chatType);
          }}
          icon="plus"
          disabled={activeNewChatType === chatType}
          dataTestAttrs={{component: 'NewChatDropdown', element: 'button'}}
        />
      </Tooltip>
    );
  } else {
    return (
      <Dropdown
        menu={
          <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.LARGE} className="dropdown-menu">
            {chatTypes.map((chatType) => (
              <Option
                key={chatType}
                value={chatType}
                onSelect={onClick}
                isDisabled={activeNewChatType === chatType}
              >
                {`${capitalize(getChatTypeText(chatType))} chat`}
              </Option>
            ))}
          </Menu>
        }
        className="u-display-inline-block dropdown"
      >
        <Button
          buttonStyle={ButtonStyle.TERTIARY_BLUE}
          size={buttonSize || ButtonSize.SMALL}
          isDropdown={false}
          icon="plus"
          dataTestAttrs={{component: 'NewChatDropdown', element: 'button'}}
        />
      </Dropdown>
    );
  }
}
